import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import styles from './CertificationsPage.module.css';
import { getAllCertificationTags, getCertificationAnchorId } from '../config/certifications';

function CertificationsPage() {
  const certifications = useMemo(() => getAllCertificationTags(), []);
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>Gear Certifications | PeaksOnFoot</title>
        <meta
          name="description"
          content="Overview of outdoor gear certifications used on PeaksOnFoot. Learn what each certification means for materials, safety, sustainability, and manufacturing standards."
        />
        <meta
          name="keywords"
          content="gear certifications, bluesign, pfc free, fair wear, RDS, UIAA, CE, outdoor equipment standards"
        />
        <meta property="og:title" content="Gear Certifications | PeaksOnFoot" />
        <meta
          property="og:description"
          content="Browse all gear certification tags and their meanings on PeaksOnFoot."
        />
        <meta name="robots" content="index,follow" />
      </Helmet>

      <div className={styles.page}>
        <div className={styles.headerRow}>
          <Link to="/gear" className={styles.backLink}>← {t('gear.back', 'Back to Gear')}</Link>
          <h1>{t('certificationsTitle', 'Gear Certifications')}</h1>
        </div>


        <div className={styles.grid}>
          {certifications.map((certification) => {
            const anchorId = getCertificationAnchorId(certification);
            return (
              <section key={certification} id={anchorId} className={styles.card}>
                <h2>{certification}</h2>
                <p>
                  {t(`certifications.${certification}`, '')}
                </p>
              </section>
            );
          })}
        </div>
      </div>
    </>
  );
}

export default CertificationsPage;
